import ApplicationController from '../application_controller';

export default class extends ApplicationController {
  static targets = ['selectionCount', 'checkbox'];

  selectedServices = [];

  checkboxTargetConnected(target) {
    this.toggleServices(target);
    this.updateSelectedServicesCount();
  }

  disconnect() {
    this.selectedServices = [];
  }

  updateServices(event) {
    this.toggleServices(event.target);
    this.updateSelectedServicesCount();
  }

  // Private

  toggleServices({ checked, value, dataset }) {
    if (checked) {
      const serviceObject = { id: value, charge: Number(dataset.charge) };
      this.selectedServices.push(serviceObject);
      this.dispatch('select', { detail: serviceObject, bubbles: true });
      this.dispatchChangeEvent();
      return;
    }

    const index = this.selectedServices.findIndex((service) => service.id === value);
    if (index === -1) return;

    const service = this.selectedServices[index];
    this.selectedServices.splice(index, 1);

    this.dispatch('deselect', { detail: { id: service.id, charge: service.charge }, bubbles: true });
    this.dispatchChangeEvent();
  }

  updateSelectedServicesCount() {
    if (!this.hasSelectionCountTarget) return;
    this.selectionCountTarget.innerText = this.selectedServices.length.toString();
  }

  dispatchChangeEvent() {
    this.dispatch('change', { detail: { selectedServices: this.selectedServices }, bubbles: true });
  }
}
